import { Banner } from '@cbhq/cds-web/banner/Banner';
import { TextLabel2 } from '@cbhq/cds-web/typography';
import { memo, ReactNode, useMemo } from 'react';
import { IconName } from '@cbhq/cds-common';

export type PromotionalBannerColor = 'green' | 'default';
export type PromotionalBannerProps = {
  icon: IconName;
  title: string;
  description: string | ReactNode;
  color?: PromotionalBannerColor;
  testID?: string;
  primaryAction?: ReactNode;
};

const COLORS = {
  green: {
    backgroundColor: 'rgb(var(--green0))',
    borderColor: 'rgb(var(--green20))',
    iconColor: 'rgb(var(--green60))',
    titleColor: 'rgb(var(--green60))',
  },
  default: undefined,
};

export const PromotionalBanner = memo(function PromotionalBanner({
  icon,
  title,
  description,
  color = 'green',
  primaryAction,
  testID,
}: PromotionalBannerProps) {
  const style = useMemo(() => {
    const colorConfig = COLORS[color];
    if (colorConfig) {
      return {
        backgroundColor: colorConfig.backgroundColor,
        borderColor: colorConfig.borderColor,
        '--primary': colorConfig.iconColor,
        '--foreground': colorConfig.titleColor,
      };
    }
    return {};
  }, [color]);
  return (
    <Banner
      startIcon={icon}
      title={title}
      variant="promotional"
      testID={testID}
      primaryAction={primaryAction}
      style={style}
    >
      <TextLabel2 as="span" color="fgMuted">
        {description}
      </TextLabel2>
    </Banner>
  );
});
